import { observer } from 'mobx-react';
import type { JSX } from 'react';
import { InvitationStatus } from '../../Store/InvitationStore/Types';

interface Props {
  invitationStatus: InvitationStatus;
  children: JSX.Element;
}

function InactiveRow({ invitationStatus, children }: Props) {
  switch (invitationStatus) {
    case 'active':
      return <tr>{children}</tr>;
    case 'inactive':
      return <tr className="bg-gray-50">{children}</tr>;
  }
}

export default observer(InactiveRow);
